import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface NetworkState {
  isOnline: boolean;
  connectionType: string;
  connectionQuality: 'good' | 'fair' | 'poor' | 'unknown';
  lastOnline?: number;
  lastOffline?: number;
  isSyncing: boolean;
  syncProgress: number;
  pendingSyncCount: number;
}

const initialState: NetworkState = {
  isOnline: true,
  connectionType: 'unknown',
  connectionQuality: 'unknown',
  isSyncing: false,
  syncProgress: 0,
  pendingSyncCount: 0
};

const networkSlice = createSlice({
  name: 'network',
  initialState,
  reducers: {
    setNetworkStatus: (state, action: PayloadAction<Partial<NetworkState>>) => {
      return { ...state, ...action.payload };
    },
    setOnlineStatus: (state, action: PayloadAction<boolean>) => {
      state.isOnline = action.payload;
      if (action.payload) {
        state.lastOnline = Date.now();
      } else {
        state.lastOffline = Date.now();
      }
    },
    setSyncStatus: (state, action: PayloadAction<{ isSyncing: boolean; progress?: number }>) => {
      state.isSyncing = action.payload.isSyncing;
      if (action.payload.progress !== undefined) {
        state.syncProgress = action.payload.progress;
      }
    },
    setPendingSyncCount: (state, action: PayloadAction<number>) => {
      state.pendingSyncCount = action.payload;
    },
    resetNetworkState: () => initialState
  }
});

export const {
  setNetworkStatus,
  setOnlineStatus,
  setSyncStatus,
  setPendingSyncCount,
  resetNetworkState
} = networkSlice.actions;

export default networkSlice.reducer;